
export {SearchGamesManager};

import {e, get_cookie} from './utils.js';
import {PlayListMgr, SearchOpsMgr, SetupMgr, state, get_game, get_match} from './index.js';
import {DataTable} from './datatable.js';

// ---------------------------
// SEARCH state.games MANAGER
// ---------------------------

function SearchGamesManager() {

	// ---------------------------
	// Properties
	// ---------------------------

	const GamesTable = new DataTable(e("games_page"), "", false, true, this);
	let GameRecs = [];

	// Add heads
	GamesTable.add_head("gamecheck", "checkbox", "X", "center", 1);
	GamesTable.add_head("created", "date", "Date", "left", 2);
	if (state.touch) {
		GamesTable.add_head("opponent", "str", "Event", "left", 3);
		GamesTable.add_head("gamenum", "str", "Activity", "left", 3);
	} else {
		GamesTable.add_head("opponent", "str", "Opponent", "left", 3);
	}
	GamesTable.add_head("venue", "str", "Venue", "left", 2);
	if (!state.touch) {
		GamesTable.add_head("gamenum", "int", "Game", "center", 2);
		GamesTable.add_head("score", "score", "Score", "center", 2);
	}
	GamesTable.add_head("vstate", "video", "Video", "center", 1);

	// ---------------------------
	// Functions
	// ---------------------------

	this.load_team_selector = f_load_team_selector;
	this.load_games_table   = f_load_games_table;
	this.check_all_games    = f_check_all_games;
	this.get_checked_games  = f_get_checked_games;
	this.all_games_checked  = f_all_games_checked;
	this.head_checked       = f_head_checked;
	this.cell_checked       = f_cell_checked;


	// ---------------------------
	// Loading Methods
	// ---------------------------

	function f_load_team_selector() {

		// Clear current options
		while (e("selTeam").options.length > 0) {
			e("selTeam").remove(0);
		}

		// Sort the teams based on the team name
		state.teams.sort( function(a, b) {
			if (a.name.toLowerCase() > b.name.toLowerCase()) {
				return 1;
			} else {
				return -1;
			}
		});

		// Load the teams
		for (var team in state.teams) {

			var opt       = document.createElement('option');
			opt.value     = state.teams[team].id;
			opt.innerHTML = state.teams[team].name;
			e("selTeam").add(opt);
		}

		// Update the games in the sync list when changed
		e("selTeam").onchange = function() {
			f_load_games_table();
			SearchOpsMgr.load_player_column();
			SetupMgr.load_game_selector();
			PlayListMgr.load_playlist_selector();
		};

		// Check if the team game cookie exists, else set the cookie
		var tgc = get_cookie("TEAM_GAME");
		if (tgc) {
			// Get the payload
			var payload = JSON.parse(tgc);

			// Does this team exist in the drop down? (If not, it's a holdover
			// from a different SS Video window)
			if ($("#selTeam").find('option[value="' + payload.team_id + '"]').length) {

				// Set the team selector
				e("selTeam").value = payload.team_id;

			}
		}
	}

	function f_load_games_table() {

		// Get the selected team
		if (e("selTeam").selectedIndex < 0) {
			return;
		}

		// Get the team id
		const team_id = e("selTeam").value;

		// Get the matches dict
		const matches = {};

		for (let i=0, ilen=state.matches.length; i < ilen; i++) {

			if (! state.matches[i]) {
				continue;
			}

			if (state.matches[i].team_id == team_id) {

				let match_id = state.matches[i].id;
				matches[match_id] = state.matches[i];

				if (!matches[match_id]['games']) {
					matches[match_id]['games'] = {};
				}

				for (let j=0, jlen=state.games.length; j < jlen; j++) {

					if (! state.games[j]) {
						continue;
					}

					let game_id = state.games[j].id;
					if (state.games[j].match_id == match_id) {
						matches[match_id]['games'][game_id] = state.games[j];
					}
				}
			}
		}

		// Init the games captured
		GameRecs = [];

		// Run through the team matches
		for (let match_id in matches) {

			// Get the match metadata
			let match = get_match(match_id);

			// Run through the games in the match
			for (let game_id in matches[match_id].games) {

				// Get the game
				let game   = get_game(game_id);
				let videos = state.videos[game_id];

				// Create the data record
				let game_rec = {};
				game_rec.game_id   = parseInt(game_id);
				game_rec.gamecheck = true;
				game_rec.created   = game.created;
				game_rec.opponent  = match.opponent;
				game_rec.venue     = match.venue;
				game_rec.gamenum   = state.touch ? game.name : game.num;
				game_rec.score     = game.score;
				game_rec.vstate    = (videos != undefined) ? ((videos.length > 0) ? 2 : 0) : 0;

				// Add the data rec to the games array
				GameRecs.push(game_rec);
			}
		}

		// Load the games table
		GamesTable.load_data(GameRecs);
	}


	// ---------------------------
	// Selection Methods
	// ---------------------------

	function f_check_all_games(tf) {
		for (var i = 0; i < GameRecs.length; i++) {
			if (GameRecs[i].gamecheck != undefined) {
				GameRecs[i].gamecheck.checked = tf;
			}
		}
	}


	// ---------------------------
	// Retrieval Methods
	// ---------------------------

	function f_get_checked_games() {

		var checked_games = [];

		for (var i = 0; i < GameRecs.length; i++) {
			if (GameRecs[i].gamecheck.checked) {
				checked_games.push(GameRecs[i].game_id);
			}
		}

		return checked_games;
	}

	function f_all_games_checked() {

		for (var i = 0; i < GameRecs.length; i++) {
			if (! GameRecs[i].gamecheck.checked) {
				return false;
			}
		}

		return true;
	}


	// ---------------------------
	// Events
	// ---------------------------

	function f_head_checked(prop, checked) {
		if (prop == "gamecheck") {
			f_check_all_games(checked);
		}
	}

	function f_cell_checked(gamerec, prop) {
		if (prop == "gamecheck") {
			if (gamerec[prop].checked) {
				GamesTable.get_head("gamecheck").check(f_all_games_checked());
			} else {
				GamesTable.get_head("gamecheck").check(false);
			}
		}
	}
}


